/* 
🌌 Shell UI Design System - Shell Name Component
Purpose: Animated shell name with underscore fade effect
*/

import React from 'react';

export const ShellName = ({ 
  name = 'shell',
  className = '',
  animated = true,
  ...props 
}) => {
  // Split name by underscore for animation
  const parts = name.split('_');
  
  if (parts.length === 1) {
    return (
      <div className={`shell-name-display ${className}`} {...props}>
        <span className="shell-name-part">{parts[0]}</span>
      </div>
    );
  }

  return (
    <div className={`shell-name-display ${className}`} {...props}>
      <span className="shell-name-part1">{parts[0]}</span>
      <span className={`shell-name-underscore ${animated ? 'shell-animate-underscore' : ''}`}>_</span>
      <span className="shell-name-part2">{parts.slice(1).join('_')}</span>
    </div>
  );
};

export default ShellName;